/**
 * Toggle row selection state in the selection set.
 */
export function toggleRowInSelection(
    rowId: string | number,
    selectedRowIds: Set<string | number>,
): Set<string | number> {
    const updatedSelection = new Set(selectedRowIds)
    if (updatedSelection.has(rowId)) {
        updatedSelection.delete(rowId)
    } else {
        updatedSelection.add(rowId)
    }
    return updatedSelection
}

/**
 * Toggle selection for all rows on the current page.
 */
export function toggleAllRowsSelection(
    currentPageRowIds: (string | number)[],
    selectedRowIds: Set<string | number>,
): Set<string | number> {
    const allSelected =
        currentPageRowIds.length > 0 &&
        currentPageRowIds.every((rowId) => selectedRowIds.has(rowId))
    const updatedSelection = new Set(selectedRowIds)

    if (allSelected) {
        currentPageRowIds.forEach((rowId) => updatedSelection.delete(rowId))
    } else {
        currentPageRowIds.forEach((rowId) => updatedSelection.add(rowId))
    }

    return updatedSelection
}
